import React, {useEffect, useState} from "react";
import {
    Button,
    Col,
    Form, Radio,
    Row,
} from "antd";
import {userService} from "../../services/user.service";
import {useSelector} from "react-redux";
import {MessageSuccess} from "../../components/messageSuccess/messageSuccess";

export const FormUserProfileFlag = ({
    isModalOpen,
    showFormUserProfile,
    profileInfo,handleUpdateProfile,
    genderIdentityCatalog
}) => {
    const [form] = Form.useForm();
    const [selectedIdentity, setSelectedIdentity] = useState(null);
    const companyId = useSelector((state) => state.userSettings.companyId);
    const [updatedFlag, setUpdatedFlag] = useState(false);

    const onSubmit = async (values) => {
        try {
            const response = await userService.editProfile(values, companyId);
            if (response?.success) {
                setUpdatedFlag(true);
                handleUpdateProfile();
                return setTimeout(() => setUpdatedFlag(false), 4000);
            }
        } catch (error) {
            console.error("Error en el registro:", error);
        }
        //showFormUserProfile(false);
    };

    useEffect(() => {
        if (isModalOpen) {
            form.setFieldsValue({
                identity: profileInfo?.genderIdentityId
            })
            setSelectedIdentity(profileInfo?.genderIdentityId);
            document.body.style.setProperty("overflow", "hidden", "important");
        } else {
            document.body.style.setProperty("overflow", "auto", "important");
        }
        return () => {
            document.body.style.setProperty("overflow", "auto", "important");
        };
    }, [isModalOpen]);

    return (
        <Form
            form={form}
            onFinish={onSubmit}
            layout="vertical"
            className="form-light fixed"
        >
            {
                (updatedFlag) ?
                    <MessageSuccess
                        title={"Se actualizó tu bandera correctamente"}
                        handleButtonClick={() => setUpdatedFlag(false)}
                        isSuccess={updatedFlag}
                    />
                :
                    <Row gutter={[0, 8]}>
                        <Col xs={24}>
                            <div className="form-light__title">
                                <h4>Cambia tu bandera</h4>
                                <small>Elige la bandera con la que te identificas</small>
                            </div>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                name="GenderIdentityId"
                                rules={[{ required: true, message: "*Campo requerido" }]}
                            >
                                <Radio.Group
                                    onChange={(e) => setSelectedIdentity(e.target.value)}
                                    value={selectedIdentity}
                                    rootClassName={"ant-radio-flag"}
                                >
                                    {genderIdentityCatalog.map((gender) => (
                                        <Radio key={gender.genderIdentityId} value={gender.genderIdentityId}>
                                            <div className={`flag ${gender.identityFlagName} ${selectedIdentity === gender.genderIdentityId ? "checked" : ""}`} />
                                            <p>{gender.genderName}</p>
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <div className="form-light__footer fixed">
                            <Button htmlType="button" type="default" block onClick={() => showFormUserProfile(false)}>
                                Cerrar
                            </Button>
                            <Button htmlType="submit" type="primary" block>
                                Guardar
                            </Button>
                        </div>
                    </Row>
            }
        </Form>
    );
};
